/**
 * Facebook Pixel bootstrap. Isomorphic on purpose — the snippet is rendered
 * into the SSR'd `<head>`, so it cannot live in `facebookPixel.client.ts`
 * (`.client` modules are stripped from the server bundle and the constant
 * would serialise as `undefined`).
 */
export const FACEBOOK_PIXEL_ID = "714467397482064"

/**
 * Inline `<head>` snippet, rendered by root.tsx's Layout.
 *
 * Must run before React hydrates: `fbevents.js` reads `fbclid` off the URL to
 * set the `_fbc` cookie, and the auth gate redirects `/loans/setup` ->
 * `/auth/register` (dropping the query string) the moment the app hydrates.
 * Initialising from a useEffect meant ad clicks lost their click id — exactly
 * the traffic `/loans/setup` is bought for. Mirrors backflip-mobile's
 * public/index.html.
 */
export const FACEBOOK_PIXEL_SNIPPET = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${FACEBOOK_PIXEL_ID}');fbq('track','PageView');`
